export interface IFlexMixin {
	direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse';
	align?: string;
	justify?: string;
	gap?: number;
}

export const flexMixin = ({
	align = 'center',
	justify = 'center',
	direction = 'row',
	gap = 0,
}: IFlexMixin) => ({
	display: 'flex',
	alignItems: align,
	justifyContent: justify,
	flexDirection: direction,
	gap: `${gap}px`,
});
